import { FLegacyColorTypes } from '@fantaskticedtechlimited/fui-colorlib'
import { FConfirmPopUp, FText } from '@fantaskticedtechlimited/fui-complib'
import useQBAPIService from '../../../../../apiService/questionBank'
import { QuestionDeletePopUpProps } from './types'
import * as styles from './styles'
import { FFontTypes } from '@fantaskticedtechlimited/fui-fontlib'
import { DeletePopUp } from '../../../../../Components/DeletePopUp'

export const QuestionDeletePopUp = (props: QuestionDeletePopUpProps) => {
    const qbAPIService = useQBAPIService()
    const questionId = props.question.id

    const handlePopUpClose = async () => {
        props.onClose && (await props.onClose())
    }

    const handleQuestionDelete = async (questionId: string) => {
        try {
            const result = await qbAPIService.qbQuestionDeleteByIdMutation({
                variables: {
                    questionId,
                },
            })
            if (result.data?.qbQuestionDeleteById.isSuccess) {
                props.onCallback &&
                    (await props.onCallback(
                        result.data?.qbQuestionDeleteById.data!
                    ))
                handlePopUpClose()
            } else {
                alert(
                    `Question delete failed, Reason. ${JSON.stringify(result)}`
                )
            }
        } catch (error) {
            console.log('error', error)
            alert(`Question delete failed, Error: ${JSON.stringify(error)}`)
        }
    }

    return (
        <DeletePopUp
            targetType="Question"
            targetName={questionId}
            onClose={handlePopUpClose}
            onActionButtonClick={() => handleQuestionDelete(questionId)}
        />
    )
}
